export default __webpack_public_path__ + "static/_borrow-mockup-desktop 2-fdc5c6c5c8bbb662b9592af06fff3c5a.png";